/**
 * Created by yangxx on 2016/12/14.
 * 几何计算工具类
 */
'use strict';
define(['./CommonUtil','../g2'], function(CommonUtil,g2) {
    /**
     * @namespace
     * @description 几何计算、处理工具类
     * @alias  G.utils.GeometryUtil
     */
    var util = {};


    util._wktReader = null;
    util._wktWriter = null;
    util._geoJSONReader = null;
    util._geoJSONWriter = null;


    /**
     * 获取wkt读取器
     * @ignore
     * @alias getWktReader
     * @memberof G.utils.GeometryUtil
     * @returns {Object} -jsts.io.WKTReader
     */
    util.getWktReader = function() {
        if (this._wktReader == null) {
            this._wktReader = new jsts.io.WKTReader(
                new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000))
            );
        }
        return this._wktReader;
    }

    /**
     * 获取wkt写出器
     * @ignore
     * @alias getWktWriter
     * @memberof G.utils.GeometryUtil
     * @returns {Object} -jsts.io.WKTWriter
     */
    util.getWktWriter = function() {
        if (this._wktWriter == null) {
            this._wktWriter = new jsts.io.WKTWriter(
                new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000))
            );
        }
        return this._wktWriter;
    }


    /**
     * 获取geojson读取器
     * @ignore
     * @alias getGeoJSONReader
     * @memberof G.utils.GeometryUtil
     * @returns {Object} -jsts.io.GeoJSONReader
     */
    util.getGeoJSONReader = function() {
        if (this._geoJSONReader == null) {
            this._geoJSONReader = new jsts.io.GeoJSONReader(
                new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000))
            );
        }
        return this._geoJSONReader;
    }

    /**
     * 获取geojson写出器
     * @ignore
     * @alias getGeoJSONWriter
     * @memberof G.utils.GeometryUtil
     * @returns {Object} -jsts.io.GeoJSONWriter
     */
    util.getGeoJSONWriter = function() {
        if (this._geoJSONWriter == null) {
            this._geoJSONWriter = new jsts.io.GeoJSONWriter(
                new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000))
            );
        }
        return this._geoJSONWriter;
    }


    var numRegex = /^\-?\d{0,}(\.\d{0,})?$/;

    /**
     * 验证经纬度
     * @alias validateLngLat
     * @memberof G.utils.GeometryUtil
     * @param lng {Number} 必填，lng坐标
     * @param lat {Number} 必填，lat坐标
     * @returns {Array} [lng,lat] 数组,坐标不合法返回false
     */
    util.validateLngLat = function(lng, lat) {
        if (numRegex.test(lng) && numRegex.test(lat)) {
            var longitude = parseFloat(lng);
            var latitude = parseFloat(lat);
            if (CommonUtil.assertWithin(longitude, '[-180,180]') &&
                CommonUtil.assertWithin(latitude, '[-90,90]')) {
                return [longitude, latitude];
            }
        }
        return false;
    }

    /**
     * 验证经纬度
     * @ignore
     * @method
     * @param x {Number} 必填，x坐标
     * @param y {Number} 必填，y坐标
     * @returns {Array} [x,y]数组,坐标不合法返回false
     */
    util.validateCoordinate = function(x, y) {
        if (numRegex.test(x) && numRegex.test(y)) {
            var xx = parseFloat(x);
            var yy = parseFloat(y);
            return [xx, yy];
        }
        return false;
    }

    /**
     * 根据中心点等获取螺旋形状的点坐标
     * @ignore
     * @alias getSpiderfy
     * @memberof G.utils.GeometryUtil
     * @param center {string} 中心点坐标
     * @param count {Number} 点的个数
     * @param spiralLengthStart {number} 半径起始
     * @param spiralLengthFactor {number} 半径增长
     * @param spiralFootSeparation {number} 半径尾数
     * @returns {Array}
     */
    util.getSpiderfy = function(center, count, spiralLengthStart, spiralLengthFactor, spiralFootSeparation) {
        spiralLengthStart = spiralLengthStart || 10;
        spiralLengthFactor = spiralLengthFactor || 5;
        spiralFootSeparation = spiralFootSeparation || 28;
        var spiderfyDistanceMultiplier = 1,
            legLength = spiderfyDistanceMultiplier * spiralLengthStart,
            separation = spiderfyDistanceMultiplier * spiralFootSeparation,
            lengthFactor = spiderfyDistanceMultiplier * spiralLengthFactor * 2 * Math.PI;
        var angle = 0,
            res = [],
            i;
        for (i = count - 1; i >= 0; i--) {
            angle += separation / legLength + i * 0.0005;
            var x = center[0] + legLength * Math.cos(angle),
                y = center[1] + legLength * Math.sin(angle);
            res[i] = [x, y];
            legLength += lengthFactor / angle;
        }
        return res;
    }

    /**
     * 获取圆上的点
     * @alias getCirclePonits
     * @memberof G.utils.GeometryUtil
     * @param options {Object} 必填，参数
     * @param options.center {Array} 必填 圆心
     * @param options.radius {Number} 必填，半径
     * @param options.count {Number} 必填，点数，默认为128
     * @param options.spatialReference {Number} 必填，中心点坐标系， 默认为3857
     * @returns {Array}
     */
    util.getCirclePonits = function(options) {
        var center = options.center,
            count = options.count || 128,
            radius = parseFloat(options.radius),
            spatialReference = options.spatialReference || 3857;
        var ic = (Math.PI * 2) / count,
            icc = 360 / count;
        var arr = [],
            cx = center[0],
            cy = center[1];
        if (spatialReference == '4326' ||
            spatialReference == '4490') { //经纬度坐标系返回椭圆
            for (var i = 0; i < count; i++) {
                var degree = icc * i;
                var pt = this.getGeographyDistancePoint(center, degree, radius);
                arr.push(pt);
            }
        } else { //其他返回圆
            for (var i = 0; i < count; i++) {
                var rad = ic * i;
                var x = cx + radius * Math.cos(rad);
                var y = cy + radius * Math.sin(rad);
                arr.push([x, y]);
            }
        }
        return arr;
    }

    /**
     * 根据中心点和半径获取缓冲区椭圆上的点
     * @ignore
     * @alias getGeographyDistancePoint
     * @memberof G.utils.GeometryUtil
     * @param centerCoords {Array} 必填 ，[x,y]
     * @param degree   {Number} 必填，角度/度
     * @param distance  {Number} 必填      距离/米
     * @returns {Array}
     */
    util.getGeographyDistancePoint = function(centerCoords, degree, distance) {
        if (!CommonUtil.isArray(centerCoords)) {
            throw (new Error('参数错误！'));
        }
        //修复x 或者 y 为0 的bug
        centerCoords[0] = refineCoordinate(centerCoords[0]);
        centerCoords[1] = refineCoordinate(centerCoords[1]);
        //
        distance = distance / 6378137;
        degree = degree * Math.PI / 180;
        var lat1 = centerCoords[1] * Math.PI / 180,
            lon1 = centerCoords[0] * Math.PI / 180;
        var lat2 = Math.asin(Math.sin(lat1) * Math.cos(distance) +
            Math.cos(lat1) * Math.sin(distance) * Math.cos(degree));
        var lon2 = lon1 + Math.atan2(Math.sin(degree) * Math.sin(distance) *
            Math.cos(lat1),
            Math.cos(distance) - Math.sin(lat1) *
            Math.sin(lat2));
        if (isNaN(lat2) || isNaN(lon2)) return null;
        return [lon2 * 180 / Math.PI, lat2 * 180 / Math.PI];
        //处理坐标修复x 或者 y 为0 的bug
        function refineCoordinate(val) {
            var result = val,
                threshold = 0.00001;
            if (Math.abs(result) < threshold) {
                result = threshold;
            }
            return result;
        }
    }

    /**
     * 获取几何的中心点
     * @ignore
     * @alias getGeometryCenter
     * @memberof G.utils.GeometryUtil
     * @param geometry {g2.sfs.Geometry} 必填，点线面对象
     * @returns {g2.sfs.Point}
     */
    util.getGeometryCenter = function(geometry) {
        //wkt解析器
        var geomFactory = new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000));
        var reader = new jsts.io.WKTReader(geomFactory);
        if (geometry.getGeometryType() == g2.sfs.GeometryType.Point) {
            return geometry;
        }
        if (geometry.getGeometryType() == g2.sfs.GeometryType.Polyline) {
            return geometry.middlePoint();
        } else if (geometry.getGeometryType() == g2.sfs.GeometryType.Polygon ||
            geometry.getGeometryType() == g2.sfs.GeometryType.MultiPolygon) { //面
            var jsts_geom = reader.read(geometry.asWkt());
            var center = jsts_geom.getCentroid();
            center = g2.sfs.GeometryFormatter.fromWKT(center.toString());
            return center;
        }
    }

    /**
     * 米转弧度
     * @alias meter2Rad
     * @memberof G.utils.GeometryUtil
     * @param meter {number} 米制数值
     * @returns {number} 弧度数值
     */
    util.meter2Rad = function(meter) {
        return meter * 360 / (2 * Math.PI * 6378137);
    }

    /**
     * 测量长度
     * @ignore
     * @alias measureLength
     * @memberof G.utils.GeometryUtil
     * @param geometry {g2.sfs.Polyline} 必填-线对象
     * @returns {*|number} 两点间距离数值
     */
    util.measureLength = function(geometry) {
        if (!(geometry instanceof g2.sfs.Polyline || geometry instanceof g2.sfs.LineString)) {
            throw (new Error('参数类型错误！'));
        }
        var projectService = new g2.sfs.CoordinateTransform();
        var measureService = new g2.sfs.MeasureService({ projectService: projectService });
        var length = measureService.length(geometry);
        return length;
    };

    /**
     * 测量面积
     * @ignore
     * @alias measureArea
     * @memberof G.utils.GeometryUtil
     * @param geometry {g2.sfs.Polygon} 面几何对象
     * @returns {*|Number} 面积数值
     */
    util.measureArea = function(geometry) {
        if (!(geometry instanceof g2.sfs.Polygon)) {
            throw (new Error('参数类型错误！'));
        }
        var projectService = new g2.sfs.CoordinateTransform();
        var measureService = new g2.sfs.MeasureService({ projectService: projectService });
        var area = measureService.area(geometry);
        return area;
    };

    /**
     * 几何抽稀
     * @ignore
     * @alias simplify
     * @memberof G.utils.GeometryUtil
     * @param geom {Object} -jsts.geom.Geometry,必填 jsts Geometry对象
     * @param distanceTorlance {Number} 可选，抽稀距离
     * @returns {Object} -jsts.geom.Geometry,抽稀后的geom对象
     */
    util.simplify = function(geom, distanceTorlance) {
        var tmp_distance = geom.getLength() / geom.getNumPoints() *
            3.82;
        if (tmp_distance > distanceTorlance) {
            tmp_distance = distanceTorlance;
        }
        geom = jsts.simplify.DouglasPeuckerSimplifier.simplify(geom, tmp_distance);
        return geom;
    }


    /**
     *  转换为jsts几何对象
     * @ignore
     * @alias toJstsGeometry
     * @memberof G.utils.GeometryUtil
     * @param geom {Object} -g2.sfs.Geometry or Wkt or GeoJSON,geometry对象
     * @returns {Object} -jsts.geom.Geometry
     */
    util.toJstsGeometry = function(geom) {
        var resultObj = util._getJstsGeometry(geom) || {};
        return resultObj.geometry || null;
    }

    /**
     * 从jsts几何对象转换为g2.sfs.Geometry/Wkt/GeoJSON格式
     * @ignore
     * @alias fromJstsGeometry
     * @memberof G.utils.GeometryUtil
     * @param opts {Object} 必填
     * @param opts.jstsGeom {Object} 必填,jsts.geom.Geometry
     * @param opts.type  {String} 必填，可选值包括：'g2geom'、'wkt','geojson'，默认为'g2geom'(tsgis的几何对象)
     * @param opts.spatialReference {Number} 可选，几何的坐标系，当type为'g2geom'时需要传递，默认为4326
     * @returns {Object} -g2.sfs.Geometry or Wkt or GeoJSON
     */
    util.fromJstsGeometry = function(opts) {
        opts = opts || {};
        var obj = {
            'g2geom': 1,
            'wkt': 2,
            'geojson': 3
        }
        if (!(opts.jstsGeom instanceof jsts.geom.Geometry &&
                obj[opts.type])) {
            throw (new Error('参数错误！'));
        }
        return util._fromJstsGeometry({
            geometry: opts.jstsGeom,
            type: obj[opts.type],
            spatialReference: opts.spatialReference
        });
    }

    /**
     * 获取jsts几何对象；
     * @param geom {Object} -geometry对象,g2.sfs.Geometry
     * @returns {*}
     * @private
     */
    util._getJstsGeometry = function(geom) {
        if (!geom) {
            return null;
        }
        var obj = {},
            type, jstsGeom;
        /***
         * 使用 geom instanceof g2.sfs.Geometry 无法判断；
         * 暂时根据有无asWkt方法判断是否是ts-gis的几何对象；
         */
        if (geom instanceof jsts.geom.Geometry) {
            jstsGeom = geom;
            type = 0;
        } else if (util._getG2GeometryType(geom) != null) {
            var wkt = geom.asWkt();
            jstsGeom = util.getWktReader().read(wkt);
            type = 1;
        } else if (typeof geom == 'string') {
            jstsGeom = util.getWktReader().read(geom);
            type = 2;
        } else { //默认geojson对象
            jstsGeom = util.getGeoJSONReader().read(geom);
            //
            type = 3;
        }
        //
        if (jstsGeom) {
            var jsonObj = util.getGeoJSONWriter().write(jstsGeom);
            //处理面不闭合的问题
            if (jsonObj && jsonObj.type) {
                if (jsonObj.type.toUpperCase() == 'POLYGON') {
                    var paths = jsonObj.coordinates;
                    handlePolygon(paths);
                } else if (jsonObj.type.toUpperCase() == 'MULTIPOLYGON') {
                    var polygons = jsonObj.coordinates,
                        n = 0,
                        len = polygons.length;
                    for (; n < len; n++) {
                        var paths = polygons[n];
                        handlePolygon(paths);
                    }
                }
                jstsGeom = util.getGeoJSONReader().read(jsonObj);
            }
        }
        //
        return {
            type: type, //0=jsts;1=tsgis几何对象类型；2：wkt字符串；3：geojson对象
            geometry: jstsGeom
        }
        //
        function handlePolygon(paths) {
            var k = 0,
                len = paths.length;
            for (; k < len; k++) {
                var path = paths[k];
                var first = path[0],
                    last = path[path.length - 1];
                if (first && first.length == 2 && last && last.length == 2) {
                    if (first[0] == last[0] && first[1] == last[1]) {} else {
                        path.push([first[0], first[1]]);
                    }
                }
            }
        }
    }


    /**
     * jstsgeometry对象转换成其他对象
     * @method
     * @private
     * @param options {Object} 参数对象
     * @param options.geometry {jsts.geom.Geometry} -geometry对象
     * @param options.type {number} -1，2，3值
     * @param options.spatialReference {string} -空间参考
     */
    util._fromJstsGeometry = function(options) {
        var jstsGeom = options.geometry,
            type = options.type || 1,
            resultGeom = null;
        if (jstsGeom) {
            switch (type) {
                case 1:
                    {
                        resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
                        resultGeom.spatialReference = options.spatialReference || '4326';
                        break;
                    }
                case 2:
                    {
                        resultGeom = jstsGeom.toString();
                        break;
                    }
                case 3:
                    {
                        if (jstsGeom.CLASS_NAME == 'jsts.geom.GeometryCollection') {
                            if (jstsGeom.geometries.length == 0) {
                                jstsGeom = null;
                            }
                        }
                        if (jstsGeom) {
                            resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
                            resultGeom = resultGeom.asGeoJson();
                        }
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
        return resultGeom;
    }

    /**
     * 判断对象所属的tsgis几何类型
     * @method
     * @param geom {Object} 必填，对象
     * @returns {Function} 所属类实例
     * @private
     */
    util._getG2GeometryType = function(geom) {
        var geoms = g2.sfs;
        var geomClazz = null;
        for (var key in geoms) {
            var clazz = geoms[key];
            if (CommonUtil.isFunction(clazz)) {
                if (geom instanceof clazz) {
                    geomClazz = clazz;
                    break;
                } else if (geom.$type && geom.$type.split(',')[0]===key){
                    geomClazz = clazz;
                    break;
                }
            }
        }
        return geomClazz;
    }

    /**
     * 判断对象所属的tsgis几何类型
     * @method
     * @param geom {Object} 必填，对象
     * @returns {Function} 所属类实例
     */
    util.getG2GeometryType = function(geom) {
        return util._getG2GeometryType(geom);
    }

    /**
     * 获取多个空间要素的最小外包矩形
     * @alias getGeometryEnvlop
     * @memberof G.utils.GeometryUtil
     * @param geometryArr {Array} 必填，可以传递g2.sfs.Geometry对象、wkt字符串、geojson对象数组；
     * @returns {*} 返回对象与传入的类型一致；
     */
    util.getGeometryEnvlop = function(geometryArr) {
        if (!geometryArr || geometryArr.length < 1) {
            return null;
        }
        var envelop = null,
            resultGeom = null,
            type = 0;
        var jstsGeomArr = [];
        for (var i = 0, len = geometryArr.length; i < len; i++) {
            var geom = geometryArr[i];
            if (geom) {
                var geomObj = this._getJstsGeometry(geom);
                if (geomObj) {
                    var jstsGeom = geomObj.geometry;
                    type = geomObj.type;
                    jstsGeomArr.push(jstsGeom);
                    if (jstsGeom) {
                        if (!envelop) {
                            if (jstsGeom.CLASS_NAME == 'jsts.geom.Point') {
                                var x = jstsGeom.coordinate.x,
                                    y = jstsGeom.coordinate.y,
                                    minGap = 0.000001;
                                envelop = new jsts.geom.Envelope(x - minGap, x + minGap, y - minGap, y + minGap);
                            } else {
                                envelop = jstsGeom.getEnvelopeInternal();
                            }
                        } else {
                            envelop.expandToInclude(jstsGeom.getEnvelopeInternal());
                        }
                    }
                }
            }
        }

        if (envelop) {
            var wkt = 'POLYGON((';
            wkt += envelop.getMinX() + ' ' + envelop.getMinY() + ',';
            wkt += envelop.getMaxX() + ' ' + envelop.getMinY() + ',';
            wkt += envelop.getMaxX() + ' ' + envelop.getMaxY() + ',';
            wkt += envelop.getMinX() + ' ' + envelop.getMaxY() + ',';
            wkt += envelop.getMinX() + ' ' + envelop.getMinY();
            wkt += '))';
            switch (type) {
                case 1:
                    {
                        resultGeom = g2.sfs.GeometryFormatter.fromWKT(wkt);
                        break;
                    }
                case 2:
                    {
                        resultGeom = wkt;
                        break;
                    }
                case 3:
                    {
                        resultGeom = g2.sfs.GeometryFormatter.fromWKT(wkt);
                        resultGeom = resultGeom.asGeoJson();
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
        return resultGeom;
    }

    /**
     * 获取标绘元素的最小外包矩形
     * @alias getPlotEnvlop
     * @memberof G.utils.GeometryUtil
     * @param plotArray {Array} 必填，g2.sfs.PlotElement的数组
     * @returns {Object} -jsts.geom.Envlop
     *  {
     */
    util.getPlotEnvlop = function(plotArray, spatialReference) {
        var envlop = null,
            jstsEnv = null,
            spatialReference = spatialReference || 4326;
        if (plotArray) {
            for (var k in plotArray) {
                var ele = plotArray[k];
                if (ele) {
                    var jtsGeom = getPlotEnvlopGeometry(ele);
                    if (jtsGeom) {
                        if (!jstsEnv) {
                            jstsEnv = jtsGeom;
                        } else {
                            jstsEnv = jstsEnv.union(jtsGeom).getEnvelope();
                        }
                    }
                }
            }
        }
        if (jstsEnv) {
            var wkt = jstsEnv.toString();
            envlop = g2.sfs.GeometryFormatter.fromWKT(wkt);
            if (envlop.shell) {
                for (var m = 0; m < envlop.shell.points.length; m++) {
                    envlop.shell.points[m].spatialReference = spatialReference
                }
                envlop.shell.spatialReference = spatialReference;
            }
            envlop.spatialReference = spatialReference;
        }
        return envlop;
        //获取jts对象
        function getPlotEnvlopGeometry(plot) {
            var eleArr = plot.elements || [];
            var geoms = [],
                envlop = null;
            for (var i = 0, len = eleArr.length; i < len; i++) {
                var el = eleArr[i];
                if (el) {
                    var geom = el.geometry;
                    geoms.push(geom.asWkt());
                }
            }
            if (geoms.length > 0) {
                var wkt = util._unionGeometry(geoms);
                var geometry = util.getWktReader().read(wkt);
                envlop = geometry.getEnvelope();
            }
            return envlop;
        }
    }

    /**
     * 合并多个几何对象
     * @method
     * @private
     * @param geometryArr {Array} 必填，可以传递g2.sfs.Geometry对象、wkt字符串、geojson对象数组；
     * @returns 返回对象与传入的类型一致；
     */
    util._unionGeometry = function(geometryArr) {
        if (!geometryArr || geometryArr.length < 1) {
            return null;
        }
        var k = 0,
            len = geometryArr.length,
            unionGeom = null,
            resultGeom = null,
            type = 0;
        var unit = 360 / (2 * Math.PI * 6378137);
        for (; k < len; k++) {
            var geom = geometryArr[k],
                jstsGeom;
            /***
             * 使用 geom instanceof g2.sfs.Geometry 无法判断；
             * 暂时根据有无asWkt方法判断是否是ts-gis的几何对象；
             */
            var object = this._getJstsGeometry(geom);
            if (object) {
                jstsGeom = object.geometry;
                if (!(jstsGeom instanceof jsts.geom.Point)) {
                    //1m抽稀
                    jstsGeom = jsts.simplify.DouglasPeuckerSimplifier.simplify(jstsGeom, unit);
                }
                type = object.type;
            }
            if (jstsGeom) {
                if (unionGeom) {
                    if (unionGeom.contains(jstsGeom)) {} else if (unionGeom.within(jstsGeom)) {
                        unionGeom = jstsGeom;
                    } else {
                        unionGeom = unionGeom.union(jstsGeom);
                    }
                } else {
                    unionGeom = jstsGeom;
                }
            }
        }
        if (unionGeom) {
            switch (type) {
                case 1:
                    {
                        resultGeom = g2.sfs.GeometryFormatter.fromWKT(unionGeom.toString());
                        break;
                    }
                case 2:
                    {
                        resultGeom = unionGeom.toString();
                        break;
                    }
                case 3:
                    {
                        resultGeom = g2.sfs.GeometryFormatter.fromWKT(unionGeom.toString());
                        resultGeom = resultGeom.asGeoJson();
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
        return resultGeom;
    }

    /**
     * @ignore
     */
    util.esriGeom2TSGISGeom = function(type, geometry, defaultSpatialReference) {
        var spatialReference = defaultSpatialReference;
        if (geometry.spatialReference) {
            spatialReference = geometry.spatialReference.latestWkid;
        }
        var geoJson = ArcGISToGeoJSON.arcgisToGeoJSON(geometry);
        var geom = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geoJson, spatialReference);
        return geom;
    }


    /**
     * 求距离支持点线面， 4326坐标系
     * @ignore
     */
    util.getDistance = function(geojson1, geojson2 , spatialReference) {
        spatialReference = spatialReference || 4326;
        const projectService = new egis.sfs.CoordinateTransform();
        const geometry1 = egis.sfs.GeometryFactory.createGeometryFromGeoJson(geojson1);
        const geometry2 = egis.sfs.GeometryFactory.createGeometryFromGeoJson(geojson2);
        geometry1.spatialReference = spatialReference;
        geometry2.spatialReference = spatialReference;
        const mercatorGeom1 = projectService.transform(geometry1, 3857);
        const mercatorGeom2 = projectService.transform(geometry2, 3857);
        const jtsGeom1 = G.utils.GeometryUtil.getWktReader().read(mercatorGeom1.asWkt());
        const jtsGeom2 = G.utils.GeometryUtil.getWktReader().read(mercatorGeom2.asWkt());
        return jtsGeom1.distance(jtsGeom2);
    }

    return util;
})